<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <div>
      <div class="row">
        <div class="col-12">
          <h3 class="generalSubtitle">Datos Cliente</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-3 mb-4">
            <div class="generalTitleItemModal">Nombre</div>
            <div>{{ name || '-' }}</div>
        </div>
        <div class="col-12 col-lg-3 mb-4">
            <div class="generalTitleItemModal">Apellidos</div>
            <div>{{ surname1 || '-' }}</div>
        </div>
        <div class="col-12 col-lg-3 mb-4">
            <div class="generalTitleItemModal">Tipo de doc</div>
            <div>{{ documentType || '-' }}</div>
        </div>
        <div class="col-8 col-lg-3 mb-4">
            <div class="generalTitleItemModal">Numero de doc</div>
            <div>{{ documentNumber || '-' }}</div>
        </div>
        <div class="col-12 col-lg-3 mt-4">
            <div class="generalTitleItemModal">Fecha de nacimiento</div>
            <div>{{ $dateBackToFront(birthdate) }}</div>
        </div>
        <div class="col-12 col-lg-3 mt-4">
          <div class="form-group">
            <label class="generalTitleItemModal"> Teléfono</label>
            <div>{{ mobile || '-' }}</div>
          </div>
        </div>
        <div class="col-12 col-lg-5 mt-4">
          <div class="form-group">
            <label class="generalTitleItemModal">Email</label>
            <div>{{ email || '-' }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h3 class="generalSubtitle">Dirección</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-4 col-lg-2">
          <div class="form-group">
            <label class="generalTitleItemModal"> Tipo de Vía</label>
            <div>{{ streetType || '-' }}</div>
          </div>
        </div>
        <div class="col-8 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal"> Nombre de la vía</label>
            <div>{{ street || '-' }}</div>
          </div>
        </div>
        <div class=" col-12 col-lg-6">
          <div class="row">
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal">Número</label>
                <div>{{ number || '-' }}</div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal">Piso</label>
                <div>{{ floor || '-' }}</div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal">Puerta</label>
                <div>{{ door || '-' }}</div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal">Escalera</label>
                <div>{{ stair || '-' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal"> Localidad</label>
            <div>{{ city || '-' }}</div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal"> Provincia</label>
            <div>{{ state || '-' }}</div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal"> Código Postal</label>
            <div>{{ postalCode || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../Widgets/Shared/Modal.vue';
import axios from 'axios';

export default {
  name: 'InfoUser',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'numContract',
  ],
  components: {
    Modal
  },
  data() {
    return {
      classes: this.class,
      name: '',
      surname1: '',
      documentType: '',
      documentNumber: '',
      mobile: '',
      birthdate: '',
      email: '',
      streetType: '',
      street: '',
      number: '',
      floor: '',
      door: '',
      stair: '',
      postalCode: '',
      city: '',
      state: '',
    }
  },
  updated(){
    this.loadData()
  },
  methods: {
    loadData() {
      axios.get(`/contract/${this.numContract}`)
            .then((response) => {
              this.streetType = response.data.deliveryAddress.streetType || 'Calle';
              this.street = response.data.deliveryAddress.street;
              this.number = response.data.deliveryAddress.number;
              this.floor = response.data.deliveryAddress.floor;
              this.door = response.data.deliveryAddress.door;
              this.stair = response.data.deliveryAddress.stair;
              this.postalCode = response.data.deliveryAddress.postalCode;
              this.city = response.data.deliveryAddress.city;
              this.state = response.data.deliveryAddress.province;
              axios.get(`/customer/${response.data.customer.legalIdentifier}`)
              .then((response) => {
                this.name = response.data.name;
                this.surname1 = response.data.surnames;
                this.documentType = response.data.documentType || 'DNI';
                this.documentNumber = response.data.legalIdentifier;
                this.mobile = response.data.mobile;
                this.birthdate = response.data.birthdate;
                this.email = response.data.email;
                this.loadingDataCustomer = false;
              });
          });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
